// Must be synced with theme.js
const PAGE_SIDEBAR_WIDTH = 384;
const BREAKPOINT_WIDTHS = {
  sm: 480,
  md: 768,
  lg: 1024,
};
const MEDIA_QUERIES = {
  sm: `(max-width: ${BREAKPOINT_WIDTHS.sm / 16}em)`,
  md: `(max-width: ${BREAKPOINT_WIDTHS.md / 16}em)`,
  lg: `(max-width: ${BREAKPOINT_WIDTHS.lg / 16}em)`,
  reducedMotion: "(prefers-reduced-motion)",
};

class MediaQueryAdapter {
  mediaQuery = window.matchMedia("");

  constructor(setValue) {
    this.setValue = setValue;
  }

  onChange = (e) => {
    this.setValue({
      matches: e.matches,
    });
  };

  connect() {
    this.setValue({
      matches: this.mediaQuery.matches,
    });
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.onChange);
  }

  update(config) {
    if (config.media !== this.mediaQuery.media) {
      this.mediaQuery.removeEventListener("change", this.onChange);
      this.mediaQuery = window.matchMedia(config.media);
      this.mediaQuery.addEventListener("change", this.onChange);
      this.setValue({
        matches: this.mediaQuery.matches,
      });
    }
  }
}

export {
  BREAKPOINT_WIDTHS,
  MEDIA_QUERIES,
  MediaQueryAdapter,
  PAGE_SIDEBAR_WIDTH,
};
